import { render, staticRenderFns } from "./CollectionLog.vue?vue&type=template&id=45baf0fc&scoped=true"
import script from "./CollectionLog.vue?vue&type=script&lang=js"
export * from "./CollectionLog.vue?vue&type=script&lang=js"
import style0 from "./CollectionLog.vue?vue&type=style&index=0&id=45baf0fc&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45baf0fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45baf0fc')) {
      api.createRecord('45baf0fc', component.options)
    } else {
      api.reload('45baf0fc', component.options)
    }
    module.hot.accept("./CollectionLog.vue?vue&type=template&id=45baf0fc&scoped=true", function () {
      api.rerender('45baf0fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationRecord/collectionLog/CollectionLog.vue"
export default component.exports